import type { ChatMessageReply } from "@albertine/design-system/components/chat";
import { useMessageJump } from "./useMessageJump";

export function useScrollableReply(
    reply: ChatMessageReply | undefined,
): ChatMessageReply | undefined {
    const { pendingMessageId, jumpToMessage } = useMessageJump();

    if (!reply?.id) {
        return undefined;
    }

    const replyTargetId = reply.id;

    return {
        ...reply,
        isPending: pendingMessageId === replyTargetId,
        onPress: () => jumpToMessage(replyTargetId),
    };
}
